import bot from './bot.js';
export default {
    'en-us': Object.assign({}, bot),
};
